import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getAllDecisions, getAllImpressions } from 'redux/modules/experiments/selectors';
import { dataLayer } from 'analytics/data-layer';
import { MonetateImpressionReport } from 'redux/modules/experiments/actions/types';

let contentSquareReport!: (impressions: Record<string, MonetateImpressionReport>) => void;

const ExperimentsReporter = () => {
  const decisions: Record<string, string> = useSelector(getAllDecisions) || {};
  const impressions: Record<string, MonetateImpressionReport> =
    useSelector(getAllImpressions) || {};

  const formattedDecisions: {
    id: string;
    variant: string;
    experience_type?: string;
    experience_id?: string;
    experience_name?: string;
    experience_label?: string;
    variant_label?: string;
    control_allocation?: string;
  }[] = [];
  const formattedLabels: { [name: string]: string } = {};

  Object.entries(decisions).forEach(([id, variant]) => {
    const impression = impressions[id];

    formattedDecisions.push({
      id: `fe_${id}`,
      variant,
      experience_type: impression?.experience_type,
      experience_id: impression?.experience_id,
      experience_name: impression?.experience_name,
      experience_label: impression?.experience_label,
      variant_label: impression?.variant_label,
      control_allocation: impression?.control_allocation,
    });
    formattedLabels[`monetateExperiment_${id}`] = variant;
  });

  useEffect(() => {
    window.apm?.addLabels(formattedLabels);

    dataLayer.push({
      event: 'monetate_fe_experiment_page_load',
      monetate_fe_experiment_page_load: formattedDecisions,
    });

    async function contentSquareImpressionsReport() {
      if (!contentSquareReport) {
        contentSquareReport = (await import('./contentSquareReport')).default;
      }

      contentSquareReport(impressions);
    }

    contentSquareImpressionsReport();
  });

  return null;
};

export default ExperimentsReporter;
